import { TRACK_WEATHER_EVENT } from "../constants/actionTypes";

export function trackEvent(noun, verb, params) {
  return {
    type: TRACK_WEATHER_EVENT,
    noun,
    verb,
    params,
  };
}
